module.exports = __webpack_public_path__ + "static/media/robin_levy.0d6ef977.pdf";